import { Injectable } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { ReadingService } from '../text/reading.service';

@Injectable({
  providedIn: 'root'
})
export class TooltipReaderService {
  constructor(
    private readonly readingService: ReadingService,
    private readonly settingsService: SettingsService
  ) { }

  readTooltip(tooltip: string) {
    if (this.settingsService.settings.readTooltips) {
      this.readingService.readTooltip(tooltip);
    }
  }
}
